import { useState } from "react";
import { post } from "../networking/RequestService";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

function useUnpopProfile(profileId) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const unpopProfile = async () => {
        setLoading(true);
        setError(null);

        const payload = {
            fn: "unpop",
            profile: profileId,
            multiple: false,
        };

        try {
            const response = await post(payload);
            if (response?.data?.stat === "nok") throw response;
            return { data: response.data };
        } catch (error) {
            const errorMessage = apiErrorText(error);
            setError(errorMessage);
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { unpopProfile, loading, error };
}

export default useUnpopProfile;
